import React, { lazy } from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "../auth/ProtectedRoute";
import BITDSession00 from "../bitd/BITDSession00";
import BITDSession01 from "../bitd/BITDSession01";
import BITDClassesCore from "../bitd/BITDClassesCore";
import BITDCrewsCore from "../bitd/BITDCrewsCore";
import BITDOverview from "../bitd/BITDOverview";
import BITDCampaign from "../bitd/campaign/BITDCampaign";
import BITDCampaignDistricts from "../bitd/campaign/BITDCampaignDistricts";
import BITDCampaignDistrictsBarrowcleft from "../bitd/campaign/BITDCampaignDistrictsBarrowcleft";
import BITDCampaignDistrictsBrightstone from "../bitd/campaign/BITDCampaignDistrictsBrightstone";
import BITDCampaignDistrictsCharhollow from "../bitd/campaign/BITDCampaignDistrictsCharhollow";
import BITDCampaignDistrictsCharterhall from "../bitd/campaign/BITDCampaignDistrictsCharterhall";
import BITDCampaignDistrictsCoalridge from "../bitd/campaign/BITDCampaignDistrictsCoalridge";
import BITDCampaignDistrictsCrowsFoot from "../bitd/campaign/BITDCampaignDistrictsCrowsFoot";
import BITDCampaignDistrictsDocks from "../bitd/campaign/BITDCampaignDistrictsDocks";
import BITDCampaignDistrictsDunslough from "../bitd/campaign/BITDCampaignDistrictsDunslough";
import BITDCampaignDistrictsNightmarket from "../bitd/campaign/BITDCampaignDistrictsNightmarket";
import BITDCampaignDistrictsSilkshore from "../bitd/campaign/BITDCampaignDistrictsSilkshore";
import BITDCampaignDistrictsSixTowers from "../bitd/campaign/BITDCampaignDistrictsSixTowers";
import BITDCampaignDistrictsWhitecrown from "../bitd/campaign/BITDCampaignDistrictsWhitecrown";

const BITDDoskvolGuide = lazy(() => import("../bitd/BITDDoskvolGuide"));

const BladesInTheDarkRoutes = () => {
  return [
    <Route path="/blades-in-the-dark-session-00" element={<BITDSession00 />} />,
    <Route path="/blades-in-the-dark-session-01" element={<BITDSession01 />} />,

    <Route
      path="/blades-in-the-dark-classes-core"
      element={<BITDClassesCore />}
    />,
    <Route path="/blades-in-the-dark-crews-core" element={<BITDCrewsCore />} />,

    <Route path="/blades-in-the-dark-overview" element={<BITDOverview />} />,
    <Route
      path="/blades-in-the-dark-doskvol-guide"
      element={
        <ProtectedRoute>
          <BITDDoskvolGuide />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-introduction"
      element={<BITDCampaign />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts"
      element={<BITDCampaignDistricts />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-barrowcleft"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsBarrowcleft />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-brightstone"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsBrightstone />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-charhollow"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsCharhollow />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-charterhall"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsCharterhall />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-coalridge"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsCoalridge />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-crowsfoot"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsCrowsFoot />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-docks"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsDocks />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-dunslough"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsDunslough />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-nightmarket"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsNightmarket />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-silkshore"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsSilkshore />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-six-towers"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsSixTowers />
        </ProtectedRoute>
      }
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-whitecrown"
      element={
        <ProtectedRoute>
          <BITDCampaignDistrictsWhitecrown />
        </ProtectedRoute>
      }
    />,
  ];
};

export default BladesInTheDarkRoutes;
